import { FC, useContext, useState } from 'react';

import { AllAwbsDialog, PendingPickupsDialog, usePendingPickupsQuery } from '@/features/shipping';
import { UserTypeContext } from '@/shared/lib/UserTypeContext/UserTypeContext';

import GeneratedAwbsButton from './GeneratedAwbsButton';

type OpenDialog = 'pending' | 'all' | null;

const GeneratedAwbs: FC<{ isExpanded: boolean }> = ({ isExpanded }) => {
  const userType = useContext(UserTypeContext);
  const [openDialog, setOpenDialog] = useState<OpenDialog>(null);

  const isServices = userType === 'service';
  const { data: pendingGroups = [] } = usePendingPickupsQuery(isServices);

  if (!isServices) {
    return null;
  }

  return (
    <>
      <GeneratedAwbsButton
        isExpanded={isExpanded}
        pendingCount={pendingGroups.length}
        onClick={() => setOpenDialog('pending')}
      />

      {openDialog === 'pending' && (
        <PendingPickupsDialog
          onClose={() => setOpenDialog(null)}
          onViewAll={() => setOpenDialog('all')}
          onCourierOrdered={() => setOpenDialog('all')}
        />
      )}

      {openDialog === 'all' && <AllAwbsDialog onClose={() => setOpenDialog(null)} />}
    </>
  );
};

export default GeneratedAwbs;
